import {Pipe, PipeTransform} from "@angular/core";
import {EnumOversettelser} from "../tjenester/i18n/EnumOversettelser";
import {erNil} from "../støttefunksjoner/nilsjekk";


/**
 * Pipe for tekstrepresentasjon av enumer
 *
 * Se {@link EnumOversettelser}
 *
 * Eksempel: `{{enEnumVerdi | enum:'BenyttetSigneringsmetode' }}`
 */
@Pipe({name: 'enum', pure: true, standalone: true})
export class EnumPipe implements PipeTransform {
    constructor(private enumOversettelser: EnumOversettelser) {
    }

    transform(enumVerdi: any | null, type: EnumType): string | null {
        if (erNil(enumVerdi)) return '';

        switch (type) {
            case 'BenyttetSigneringsmetode':
                return this.enumOversettelser.oversettetBenyttetSigneringsmetode(enumVerdi);
            case 'InkludertGenerertDokument':
                return this.enumOversettelser.oversettInkludertGenerertDokument(enumVerdi);
            case 'TilgangsrolleMedlem':
                return this.enumOversettelser.tilgangsrolleMedlem(enumVerdi);
            case 'Oppgavestatus':
                return this.enumOversettelser.oversettOppgaveStatus(enumVerdi);
            case 'StemmegivningStatus':
                return this.enumOversettelser.oversettStemmegivningStatus(enumVerdi);
            case 'SigneringStatus':
                return this.enumOversettelser.oversettSigneringStatus(enumVerdi);
            default:
                return enumVerdi;
        }
    }
}

type EnumType = 'BenyttetSigneringsmetode' | 'InkludertGenerertDokument' | 'TilgangsrolleMedlem' | 'Oppgavestatus' | 'StemmegivningStatus' | 'SigneringStatus'
